module.exports = __webpack_public_path__ + "assets/images/kelvin.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/kelvin.png
 ** module id = 33
 ** module chunks = 0
 **/